// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// import { useEffect, useRef, useState } from "react";
// import {
//   IconChevronDown,
//   IconChevronUp,
//   IconCloudUpload,
//   IconDeviceFloppy,
//   IconEdit,
// } from "@tabler/icons-react";
// import { useClientProfileData, useUpdateProfile } from "../../apis/profileApis";
// import Input from "../../components/Input";
// import { useForm, Controller } from "react-hook-form";
// import toast from "react-hot-toast";
// import Configuration from "./_components/Configuration";
// import Password from "./_components/Password";
// import { getFileExtension } from "../../utilities/helper";

// type InputProps = {
//   label?: string;
//   value: string;
//   editable: boolean;
//   className?: string;
// };

// const InputField = ({ label, value, editable, className = "" }: InputProps) => (
//   <div className={`flex justify-between items-center space-y-4 ${className}`}>
//     {label && (
//       <label className="w-full text-base text-[#212121]">{label}</label>
//     )}
//     <input
//       type="text"
//       value={value}
//       disabled={!editable}
//       className={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//         editable
//           ? "bg-white border border-[#D8D8D8]"
//           : "bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//       }`}
//     />
//   </div>
// );

// const UploadButton = ({
//   label,
//   onClick,
// }: {
//   label: string;
//   onClick?: () => void;
// }) => (
//   <button
//     type="button"
//     onClick={onClick}
//     className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
//   >
//     <IconCloudUpload stroke={1} size={20} />
//   </button>
// );

// type FormValues = {
//   companyName: string;
//   contactPerson: string;
//   companyCrNo: string;
//   companyVatNo: string;
//   systemMail: string;
//   country: string;
//   email: string;
//   phoneNumber: string;
//   district: string;
//   city: string;
//   zipCode: string;
//   clientAddress: string;
//   lmAwbNumber: string;
//   shortAddress: string;
//   tollFreeNo: string;
//   crDoc: File;
//   vatDoc: File;
//   // companyLogo: File | null;
// };

// export default function Profile() {
//   const [isEdit, setIsEdit] = useState(false);
//   const [openSection, setOpenSection] = useState<string | null>("profile");

//   // toggle handler
//   const toggleSection = (section: string) => {
//     setOpenSection((prev) => (prev === section ? null : section));
//   };
//   const { data, refetch } = useClientProfileData();
//   const { mutate } = useUpdateProfile();
//   const {
//     register,
//     handleSubmit,
//     control,
//     reset,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm<FormValues>();

//   useEffect(() => {
//     if (data) {
//       setValue("companyName", data?.companyName);
//       setValue("contactPerson", data?.contactPerson);
//       setValue("email", data?.email);
//       setValue("systemMail", data?.systemMail);
//       setValue("lmAwbNumber", data?.lmAwbNumber);
//       setValue("phoneNumber", data?.phoneNumber);
//       setValue("systemMail", data?.systemMail);
//       setValue("companyCrNo", data?.companyCrNo);
//       setValue("companyVatNo", data?.companyVatNo);
//       setValue("crDoc", data?.crDocUrl);
//       setValue("vatDoc", data?.vatDocUrl);
//       setValue("country", data?.country);
//       setValue("district", data?.district);
//       setValue("city", data?.city);
//       setValue("clientAddress", data?.clientAddress);
//       setValue("zipCode", data?.zipCode);
//       setValue("tollFreeNo", data?.tollFreeNo);
//       setValue("shortAddress", data?.shortAddress);
//     }
//   }, [data]);

//   useEffect(() => {
//     if (data) {
//       reset({
//         companyName: data?.companyName || "",
//         contactPerson: data?.contactPerson || "",
//         email: data?.email || "",
//         systemMail: data?.systemMail || "",
//         lmAwbNumber: data?.lmAwbNumber || "",
//         phoneNumber: data?.phoneNumber || "",
//         companyCrNo: data?.companyCrNo || "",
//         companyVatNo: data?.companyVatNo || "",
//         crDoc: data?.crDocUrl || "",
//         vatDoc: data?.vatDocUrl || "",
//         country: data?.country || "",
//         district: data?.district || "",
//         city: data?.city || "",
//         clientAddress: data?.clientAddress || "",
//         zipCode: data?.zipCode || "",
//         tollFreeNo: data?.tollFreeNo || "",
//         shortAddress: data?.shortAddress || "",
//       });
//     }
//   }, [data, reset]);

//   const fileInputRefs = {
//     // companyLogo: useRef<HTMLInputElement>(null),
//     vatDoc: useRef<HTMLInputElement>(null),
//     crDoc: useRef<HTMLInputElement>(null),
//   };

//   const handleFileUploadClick = (fieldName: keyof typeof fileInputRefs) => {
//     fileInputRefs[fieldName].current?.click();
//   };

//   const onSubmit = (data: any) => {
//     mutate(
//       { ...data },
//       {
//         onSuccess: (data) => {
//           reset();
//           refetch();
//           setIsEdit(!isEdit);
//           toast.success("Profile Update Successfully.");
//         },
//         onError: (error) => {
//           console.log(error, "error");
//           toast.error(`${error}`);
//         },
//       }
//     );
//   };

//   return (
//     <div className="lg:w-10/12 w-11/12 mx-auto text-[#1E293B] space-y-4 py-4">
//       <div className="flex justify-between items-center">
//         <p className="text-2xl text-[#212121] tracking-[-0.5px]">
//           Company Information
//         </p>
//       </div>
//       <input
//         type="file"
//         accept=".pdf,.doc,.docx"
//         ref={fileInputRefs.vatDoc}
//         className="hidden"
//       />
//       <input
//         type="file"
//         accept=".pdf,.doc,.docx"
//         ref={fileInputRefs.crDoc}
//         className="hidden"
//       />

//       <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] space-y-4">
//         <div
//           onClick={() => toggleSection("profile")}
//           className="flex justify-between items-center cursor-pointer"
//         >
//           <h2 className="uppercase font-medium text-base text-[#212121]">
//             Profile Details
//           </h2>
//           {openSection === "profile" ? (
//             <IconChevronUp
//               onClick={() => {
//                 reset(data);
//                 setIsEdit(false);
//               }}
//               size={22}
//               stroke={1.5}
//               color="#6B7280"
//             />
//           ) : (
//             <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
//           )}
//         </div>
//         {openSection === "profile" && (
//           <>
//             <div className="grid grid-cols-6 gap-4">
//               <Input
//                 name="companyName"
//                 type="text"
//                 title="Company Name"
//                 placeholder=" "
//                 register={register}
//                 error={errors.companyName}
//                 validation={{
//                   required: "Company Name is required",
//                   pattern: {
//                     value: /^(?=.*[A-Za-z])[A-Za-z0-9\s-]+$/,
//                     message:
//                       "Company Name must include at least one letter (not only numbers)",
//                   },
//                   validate: (value) => {
//                     if (!value?.trim())
//                       return "Company Name cannot be empty or only spaces";
//                     return true;
//                   },
//                 }}
//                 className="col-span-3"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={!isEdit}
//               />
//               <Input
//                 name="contactPerson"
//                 type="text"
//                 title=" Contact Person"
//                 placeholder="Enter Name"
//                 register={register}
//                 error={errors.contactPerson}
//                 validation={{
//                   required: "Contact Person is required",
//                   pattern: {
//                     value: /^(?=.*[A-Za-z])[A-Za-z0-9\s-]+$/,
//                     message:
//                       "Contact Person Name must include at least one letter (not only numbers)",
//                   },
//                   validate: (value) => {
//                     if (!value?.trim())
//                       return "Contact Person Name cannot be empty or only spaces";
//                     return true;
//                   },
//                 }}
//                 className="col-span-3"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={!isEdit}
//               />
//               <Input
//                 name="email"
//                 type="text"
//                 title="Mail Address"
//                 placeholder="Enter Email Address"
//                 register={register}
//                 error={errors.email}
//                 validation={{ required: "Email is required" }}
//                 className="col-span-3"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={true}
//               />
//               <Input
//                 name="phoneNumber"
//                 type="number"
//                 title="Mobile Number"
//                 placeholder="Enter Mobile Number"
//                 register={register}
//                 error={errors.phoneNumber}
//                 validation={{ required: "Mobile Number is required" }}
//                 className="col-span-3"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={true}
//               />
//               <Input
//                 name="country"
//                 type="text"
//                 title="Country"
//                 placeholder=" "
//                 register={register}
//                 error={errors.country}
//                 validation={{ required: "Country is required" }}
//                 className="col-span-2"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={!isEdit}
//               />
//               <Input
//                 name="city"
//                 type="text"
//                 title="City"
//                 placeholder=" "
//                 register={register}
//                 error={errors.city}
//                 validation={{ required: "City is required" }}
//                 className="col-span-2"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={!isEdit}
//               />
//               <Input
//                 name="district"
//                 type="text"
//                 title="District"
//                 placeholder=" "
//                 register={register}
//                 error={errors.district}
//                 validation={{ required: "District is required" }}
//                 className="col-span-2"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={!isEdit}
//               />
//               <Input
//                 name="shortAddress"
//                 type="text"
//                 title="Short Address"
//                 placeholder=" "
//                 register={register}
//                 className="col-span-3"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={!isEdit}
//               />
//               <Input
//                 name="zipCode"
//                 type="text"
//                 title="Postal / ZIP Code"
//                 placeholder=" "
//                 register={register}
//                 error={errors.zipCode}
//                 validation={{ required: "Postal / ZIP Code is required" }}
//                 className="col-span-3"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={!isEdit}
//               />
//               <Input
//                 name="clientAddress"
//                 type="text"
//                 title="Address Line"
//                 placeholder=" "
//                 register={register}
//                 error={errors.clientAddress}
//                 validation={{ required: "Address  is required" }}
//                 className="col-span-6"
//                 inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                   isEdit
//                     ? "bg-white border border-[#D8D8D8]"
//                     : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                 }`}
//                 disabled={!isEdit}
//               />
//             </div>
//             <div className="md:divide-x md:divide-y-0 divide-y divide-[#d2d2d2] grid md:grid-cols-2 gap-4">
//               <div className="space-y-4 md:pr-4">
//                 <h2 className="uppercase font-medium text-sm text-[#212121]">
//                   Document
//                 </h2>
//                 <div className="space-y-1">
//                   <label className="text-sm text-[#1E293B]">
//                     VAT Percent & Number
//                   </label>
//                   <div className="flex items-center w-full gap-2 mb-3">
//                     <Input
//                       name="companyVatNo"
//                       type="number"
//                       placeholder=""
//                       register={register}
//                       error={errors.companyVatNo}
//                       validation={{
//                         validate: (value: string) => {
//                           const trimmed = value?.trim();
//                           if (trimmed && trimmed.length !== 15) {
//                             return "Tax/VAT number must be 15 digits";
//                           }
//                           return true;
//                         },
//                       }}
//                       className="w-full"
//                       labelClass="text-sm text-[#1E293B]"
//                       inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                         isEdit
//                           ? "bg-white border border-[#D8D8D8]"
//                           : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                       }`}
//                       disabled={!isEdit}
//                     />

//                     <Controller
//                       control={control}
//                       name="vatDoc"
//                       rules={{
//                         validate: (file: File) => {
//                           const vatNumber = watch("companyVatNo")
//                             ?.toString()
//                             .trim();
//                           if (vatNumber && !file) return "Please select a file";
//                           if (file) {
//                             const allowedTypes = [
//                               "image/jpeg",
//                               "image/png",
//                               "image/jpg",
//                               "application/pdf",
//                             ];
//                             if (
//                               file.type
//                                 ? !allowedTypes.includes(file.type)
//                                 : !["jpeg", "png", "jpg", "pdf"].includes(
//                                     getFileExtension(file as any)
//                                   )
//                             ) {
//                               return "Only JPG, JPEG, PDF, or PNG files are allowed";
//                             }
//                           }
//                           return true;
//                         },
//                       }}
//                       render={({ field, fieldState }) => (
//                         <div>
//                           <input
//                             type="file"
//                             id="vat-doc"
//                             className="hidden"
//                             onChange={(e) => {
//                               const file = e.target.files?.[0];
//                               if (file) field.onChange(file);
//                             }}
//                           />
//                           {field.value && !isEdit ? (
//                             // OPEN in new tab instead of direct download
//                             <a
//                               href={
//                                 field.value instanceof File
//                                   ? URL.createObjectURL(field.value)
//                                   : field.value // URL string from backend
//                               }
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="flex items-center justify-center py-[10px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
//                             >
//                               <img src="\img\download-file-icon.svg" alt="" />
//                             </a>
//                           ) : (
//                             <label
//                               htmlFor="vat-doc"
//                               className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
//                             >
//                               <IconCloudUpload stroke={1} size={20} />
//                             </label>
//                           )}
//                           {fieldState.error && (
//                             <p className="text-red-500 text-sm mt-1">
//                               {fieldState.error.message}
//                             </p>
//                           )}
//                         </div>
//                       )}
//                     />
//                   </div>
//                 </div>
//                 <div className=" space-y-1">
//                   <label className="text-sm text-[#1E293B]">CR Number</label>
//                   <div className="w-full flex items-center gap-2">
//                     <Input
//                       name="companyCrNo"
//                       type="number"
//                       placeholder=""
//                       register={register}
//                       error={errors.companyCrNo}
//                       validation={{
//                         required: "CR Number is required",
//                         validate: (value: string) => {
//                           const trimmed = value.trim();
//                           if (trimmed.length !== 10)
//                             return "CR number must be 10 numbers";
//                           return true;
//                         },
//                       }}
//                       className="w-full"
//                       inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                         isEdit
//                           ? "bg-white border border-[#D8D8D8]"
//                           : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                       }`}
//                       disabled={!isEdit}
//                     />

//                     <Controller
//                       control={control}
//                       name="crDoc"
//                       rules={{
//                         required: "File is required",
//                         validate: (file: File) => {
//                           if (!file) return "Please select a file";
//                           const allowedTypes = [
//                             "image/jpeg",
//                             "image/png",
//                             "image/jpg",
//                             "application/pdf",
//                           ];
//                           if (
//                             file.type
//                               ? !allowedTypes.includes(file.type)
//                               : !["jpeg", "png", "jpg", "pdf"].includes(
//                                   getFileExtension(file as any)
//                                 )
//                           ) {
//                             return "Only JPG, JPEG, PDF, or PNG allowed";
//                           }
//                           return true;
//                         },
//                       }}
//                       render={({ field, fieldState }) => (
//                         <div>
//                           <input
//                             type="file"
//                             id="cr-doc"
//                             className="hidden"
//                             onChange={(e) => {
//                               const file = e.target.files?.[0];
//                               if (file) field.onChange(file);
//                             }}
//                           />
//                           {field.value && !isEdit ? (
//                             <a
//                               href={
//                                 field.value instanceof File
//                                   ? URL.createObjectURL(field.value)
//                                   : field.value
//                               }
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="flex items-center justify-center py-[10px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
//                             >
//                               <img src="\img\download-file-icon.svg" alt="" />
//                             </a>
//                           ) : (
//                             <label
//                               htmlFor="cr-doc"
//                               className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
//                             >
//                               <IconCloudUpload stroke={1} size={20} />
//                             </label>
//                           )}
//                           {fieldState.error && (
//                             <p className="text-red-500 text-sm mt-1">
//                               {fieldState.error.message}
//                             </p>
//                           )}
//                         </div>
//                       )}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="space-y-4 md:pl-4 md:pt-0 pt-4">
//                 <h2 className="uppercase font-medium text-sm text-[#212121]">
//                   AWb Info
//                 </h2>
//                 <div className="grid grid-cols-2 gap-4">
//                   <Input
//                     name="lmAwbNumber"
//                     type="text"
//                     title="Fulfillment"
//                     placeholder=""
//                     register={register}
//                     inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                       isEdit
//                         ? "bg-white border border-[#D8D8D8]"
//                         : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                     }`}
//                     disabled={true}
//                   />
//                   <Input
//                     name="lmAwbNumber"
//                     type="text"
//                     title="Lastmiles"
//                     placeholder=""
//                     register={register}
//                     inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                       isEdit
//                         ? "bg-white border border-[#D8D8D8]"
//                         : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                     }`}
//                     disabled={true}
//                   />
//                   <Input
//                     name="tollFreeNo"
//                     type="number"
//                     title="AWB Toll Free No"
//                     placeholder=""
//                     register={register}
//                     inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                       isEdit
//                         ? "bg-white border border-[#D8D8D8]"
//                         : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                     }`}
//                     disabled={!isEdit}
//                   />
//                   <Input
//                     name="systemMail"
//                     type="email"
//                     title="Info Email"
//                     placeholder=""
//                     register={register}
//                     error={errors.systemMail}
//                     validation={{ required: "Info Email is required" }}
//                     inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                       isEdit
//                         ? "bg-white border border-[#D8D8D8]"
//                         : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//                     }`}
//                     disabled={!isEdit}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="pt-4">
//               <button
//                 type={isEdit ? "submit" : "button"}
//                 onClick={() => {
//                   isEdit ? handleSubmit(onSubmit)() : setIsEdit(!isEdit);
//                 }}
//                 className="bg-[#FBD037] text-[#212121] text-base font-semibold  p-2.5 rounded-full"
//               >
//                 {isEdit ? <IconDeviceFloppy /> : <IconEdit />}
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//       <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]  space-y-4">
//         <div
//           onClick={() => toggleSection("config")}
//           className="flex justify-between items-center cursor-pointer"
//         >
//           <h2 className="uppercase font-medium text-base text-[#212121]">
//             Configuration
//           </h2>
//           {openSection === "config" ? (
//             <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
//           ) : (
//             <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
//           )}
//         </div>
//         {openSection === "config" && <Configuration />}
//       </div>
//       <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]  space-y-4">
//         <div
//           onClick={() => toggleSection("resetPassword")}
//           className="flex justify-between items-center cursor-pointer"
//         >
//           <h2 className="uppercase font-medium text-base text-[#212121]">
//             Reset Password
//           </h2>
//           {openSection === "resetPassword" ? (
//             <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
//           ) : (
//             <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
//           )}
//         </div>
//         {openSection === "resetPassword" && <Password />}
//       </div>
//     </div>
//   );
// }

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import {
  IconChevronDown,
  IconChevronUp,
  IconCloudUpload,
  IconDeviceFloppy,
  IconEdit,
} from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import Input from "../../components/Input";
import { useClientProfileData, useUpdateProfile } from "../../apis/profileApis";
import { useProfileData } from "../../apis/profileApis";
import Configuration from "./_components/Configuration";
import Password from "./_components/Password";
import { useStaffUpdateMutation } from "../../apis/staffApis";

type ClientFormValues = {
  companyName: string;
  contactPerson: string;
  companyCrNo: string;
  companyVatNo: string;
  systemMail: string;
  country: string;
  email: string;
  phoneNumber: string;
  district: string;
  city: string;
  zipCode: string;
  clientAddress: string;
  lmAwbNumber: string;
  shortAddress: string;
  tollFreeNo: string;
  state: string;
  crDoc: File;
  vatDoc: File;
};

export default function Profile() {
  const profile = useSelector((state: any) => state.auth.profile);
  const isStaff = profile?.type === "lmStaff";
  const [isEdit, setIsEdit] = useState(false);
  const [openSection, setOpenSection] = useState<string | null>("profile");

  const toggleSection = (section: string) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  const clientQuery = useClientProfileData();
  const staffQuery = useProfileData();
  const { data, refetch, isLoading } = isStaff ? staffQuery : clientQuery;

  const { mutate: updateClient } = useUpdateProfile();
  const { mutate: updateStaff } = useStaffUpdateMutation();

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    formState: { errors, isDirty },
  } = useForm<ClientFormValues>();

  // for client/ admin
  useEffect(() => {
    if (!data || isStaff) return;
    reset({
      companyName: data?.companyName || "",
      contactPerson: data?.contactPerson || "",
      email: data?.email || "",
      systemMail: data?.systemMail || "",
      lmAwbNumber: data?.lmAwbNumber || "",
      phoneNumber: data?.phoneNumber || "",
      companyCrNo: data?.companyCrNo || "",
      companyVatNo: data?.companyVatNo || "",
      crDoc: data?.crDocUrl || "",
      vatDoc: data?.vatDocUrl || "",
      country: data?.country || "",
      district: data?.district || "",
      city: data?.city || "",
      clientAddress: data?.clientAddress || "",
      zipCode: data?.zipCode || "",
      tollFreeNo: data?.tollFreeNo || "",
      shortAddress: data?.shortAddress || "",
    });
  }, [data, reset, isStaff]);

  //  for staff
  useEffect(() => {
    if (!data || !isStaff) return;
    reset({
      contactPerson: data?.name || "",
      phoneNumber: data?.phone || "",
    });
  }, [data, isStaff, reset]);

  const fileInputRefs = {
    vatDoc: useRef<HTMLInputElement>(null),
    crDoc: useRef<HTMLInputElement>(null),
  };

  const handleFileUploadClick = (fieldName: keyof typeof fileInputRefs) => {
    fileInputRefs[fieldName].current?.click();
  };

  // const onSubmit = (formData: ClientFormValues) => {
  //   const onSuccessHandler = () => {
  //     refetch();
  //     setIsEdit(false);
  //     toast.success("Profile updated successfully.");
  //   };

  //   const onErrorHandler = (error: any) => {
  //     console.error(error);
  //     toast.error(error?.toString() || "Update failed");
  //   };

  //   if (isStaff) {
  //     const staffPayload = {
  //       id: data?.id,
  //       name: formData.contactPerson,
  //       phoneNumber: formData.phoneNumber,
  //     };
  //     updateStaff(staffPayload, {
  //       onSuccess: onSuccessHandler,
  //       onError: onErrorHandler,
  //     });
  //   } else {
  //     updateClient(formData, {
  //       onSuccess: onSuccessHandler,
  //       onError: onErrorHandler,
  //     });
  //   }
  // };

  const onSubmit = (formData: ClientFormValues) => {
    const onSuccessHandler = () => {
      refetch();
      setIsEdit(false);
      toast.success("Profile updated successfully.");
    };

    const onErrorHandler = (error: any) => {
      console.error(error);
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        error?.message ||
        (typeof error === 'string' ? error : null) ||
        "Failed to Update Profile";

      toast.error(errorMessage);
    };

    if (isStaff) {
      if (!isDirty) {
        toast.success("No changes were made.");
        setIsEdit(false);
        return;
      }

      const staffPayload = {
        id: data?.id,
        name: formData.contactPerson.trim(),
        phone: formData.phoneNumber.trim(),
      };

      updateStaff(staffPayload, {
        onSuccess: onSuccessHandler,
        onError: onErrorHandler,
      });
    } else {
      updateClient(formData, {
        onSuccess: onSuccessHandler,
        onError: onErrorHandler,
      });
    }
  };

  const handleCancelEdit = () => {
    if (isStaff && data) {
      reset({
        contactPerson: data.name || "",
        phoneNumber: data.phone || "",
      });
    }
    setIsEdit(false);
  };

  return (
    <div className="lg:w-10/12 w-11/12 mx-auto text-[#1E293B] space-y-4 py-4">
      <div className="flex justify-between items-center">
        <p className="text-2xl text-[#212121] tracking-[-0.5px]">
          {isStaff ? "My Profile" : "Company Information"}
        </p>
      </div>

      {!isStaff && (
        <>
          <input
            type="file"
            accept=".pdf,.doc,.docx"
            ref={fileInputRefs.vatDoc}
            className="hidden"
          />
          <input
            type="file"
            accept=".pdf,.doc,.docx"
            ref={fileInputRefs.crDoc}
            className="hidden"
          />
        </>
      )}

      <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] space-y-4">
        <div
          onClick={() => toggleSection("profile")}
          className="flex justify-between items-center cursor-pointer"
        >
          <h2 className="uppercase font-medium text-base text-[#212121]">
            {isStaff ? "Personal Details" : "Profile Details"}
          </h2>
          {openSection === "profile" ? (
            <IconChevronUp
              onClick={(e) => {
                e.stopPropagation();
                if (!isStaff) {
                  reset(data);
                } else {
                  handleCancelEdit();
                }
                toggleSection("profile");
              }}
              size={22}
              stroke={1.5}
              color="#6B7280"
            />
          ) : (
            <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
          )}
        </div>

        {openSection === "profile" && (
          <>
            {isStaff && data ? (
              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                <div className="grid grid-cols-6 gap-4">
                  <div className="col-span-3">
                    <Input
                      name="contactPerson"
                      title="Full Name"
                      type="text"
                      placeholder="Enter Full Name"
                      register={register}
                      validation={{
                        required: "Full Name is required",
                        pattern: {
                          value: /^(?=.*[A-Za-z])[A-Za-z0-9\s-]+$/,
                          message: "Name must include at least one letter",
                        },
                      }}
                      error={errors.contactPerson}
                      disabled={!isEdit}
                      inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                        ? "bg-white border border-[#D8D8D8]"
                        : "bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                        }`}
                    />
                  </div>

                  <div className="col-span-3">
                    <Input
                      name="email"
                      title="Email Address"
                      value={data.email || ""}
                      disabled={true}
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>

                  <div className="col-span-3">
                    <Input
                      name="phoneNumber"
                      title="Phone Number"
                      type="text"
                      placeholder="Enter Phone Number"
                      register={register}
                      validation={{
                        required: "Mobile number is required",
                        validate: (value: string) => {
                          const trimmed = value.trim();
                          if (trimmed.length !== 10)
                            return "Mobile number must be 10 characters";
                          return true;
                        },
                      }}
                      error={errors.phoneNumber}
                      disabled={!isEdit}
                      inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                        ? "bg-white border border-[#D8D8D8]"
                        : "bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                        }`}
                    />
                  </div>

                  <div className="col-span-3">
                    <label className="w-full text-sm">Iqama Number</label>
                    <div className="flex items-center gap-2">
                      <Input
                        name="Iqama Number"
                        value={data.iqamaNo || ""}
                        disabled
                        inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      />
                      {data.iqamaDoc ? (
                        <a
                          href={data.iqamaDoc}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-center h-[40px] w-[44px] border border-[#D2D2D2] rounded-xl bg-[#FBD037]/20"
                        >
                          <img
                            src="/img/download-file-icon.svg"
                            alt="Download Iqama"
                            className="h-5 w-5"
                          />
                        </a>
                      ) : (
                        <div className="h-[40px] flex items-center text-sm text-gray-500 px-2">
                          
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-span-3">
                    <Input
                      name="Start Date"
                      title="Start Date"
                      type="date"
                      value={data.startDate || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>
                  <div className="col-span-3">
                    <Input
                      name="Assigned Role"
                      title="Assigned Role"
                      value={data.roles || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>
                  <div className="col-span-2">
                    <Input
                      name="Country"
                      title="Country"
                      value={data.countryName || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>
                  <div className="col-span-2">
                    <Input
                      name="City"
                      title="City"
                      value={data.cityName || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>
                  <div className="col-span-2">
                    <Input
                      name="District"
                      title="District"
                      value={data.districtName || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>
                  <div className="col-span-6">
                    <Input
                      name="Address Line"
                      title="Address Line"
                      value={data.address || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>
                  <div className="col-span-3">
                    <Input
                      name="Short Address"
                      title="Short Address"
                      value={data.shortAddress || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>
                  <div className="col-span-3">
                    <Input
                      name="Time Slot Name"
                      title="Time Slot Name"
                      value={data.timeSlotName || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>
                  <div className="col-span-3">
                    <Input
                      name="Selected Warehouse"
                      title="Selected Warehouse"
                      value={data.selectedWarehouse?.name || ""}
                      disabled
                      inputClassName="px-4 py-2 text-sm w-full rounded-full outline-none bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    />
                  </div>

                  <div className="col-span-3">
                    <label className="block text-sm mb-2">
                      Assigned Warehouses
                    </label>
                    <div className="flex flex-wrap gap-4">
                      {data?.warehouseName?.length > 0 ? (
                        data.warehouseName.map((name: string, index: number) => (
                          <span
                            key={index}
                            className="px-3 py-2 bg-[#FBD037]/20 text-sm rounded-full text-[#212121]"
                          >
                            {name}
                          </span>
                        ))
                      ) : (
                        <span className="text-sm text-gray-500">
                          No warehouses assigned
                        </span>
                      )}
                    </div>
                  </div>
                </div>


                <div className="pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      if (isEdit) {
                        handleSubmit(onSubmit)();
                      } else {
                        setIsEdit(true);
                      }
                    }}
                    className="bg-[#FBD037] text-[#212121] text-base font-semibold p-2.5 rounded-full"
                  >
                    {isEdit ? (
                      <IconDeviceFloppy size={20} />
                    ) : (
                      <IconEdit size={20} />
                    )}
                  </button>
                </div>
              </form>
            ) : (
              <>
                <div className="grid grid-cols-6 gap-4">
                  <Input
                    name="companyName"
                    type="text"
                    title="Company Name"
                    placeholder=" "
                    register={register}
                    error={errors.companyName}
                    validation={{
                      required: "Company Name is required",
                      pattern: {
                        value: /^(?=.*[A-Za-z])[A-Za-z0-9\s-]+$/,
                        message:
                          "Company Name must include at least one letter (not only numbers)",
                      },
                      validate: (value) => {
                        if (!value?.trim())
                          return "Company Name cannot be empty or only spaces";
                        return true;
                      },
                    }}
                    className="col-span-3"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={!isEdit}
                  />
                  <Input
                    name="contactPerson"
                    type="text"
                    title=" Contact Person"
                    placeholder="Enter Name"
                    register={register}
                    error={errors.contactPerson}
                    validation={{
                      required: "Contact Person is required",
                      pattern: {
                        value: /^(?=.*[A-Za-z])[A-Za-z0-9\s-]+$/,
                        message:
                          "Contact Person Name must include at least one letter (not only numbers)",
                      },
                      validate: (value) => {
                        if (!value?.trim())
                          return "Contact Person Name cannot be empty or only spaces";
                        return true;
                      },
                    }}
                    className="col-span-3"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={!isEdit}
                  />
                  <Input
                    name="email"
                    type="text"
                    title="Mail Address"
                    placeholder="Enter Email Address"
                    register={register}
                    error={errors.email}
                    validation={{ required: "Email is required" }}
                    className="col-span-3"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={true}
                  />
                  <Input
                    name="phoneNumber"
                    type="number"
                    title="Mobile Number"
                    placeholder="Enter Mobile Number"
                    register={register}
                    error={errors.phoneNumber}
                    validation={{ required: "Mobile Number is required" }}
                    className="col-span-3"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={true}
                  />
                  <Input
                    name="country"
                    type="text"
                    title="Country"
                    placeholder=" "
                    register={register}
                    error={errors.country}
                    validation={{ required: "Country is required" }}
                    className="col-span-2"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={!isEdit}
                  />
                  <Input
                    name="city"
                    type="text"
                    title="City"
                    placeholder=" "
                    register={register}
                    error={errors.city}
                    validation={{ required: "City is required" }}
                    className="col-span-2"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={!isEdit}
                  />
                  <Input
                    name="district"
                    type="text"
                    title="District"
                    placeholder=" "
                    register={register}
                    error={errors.district}
                    validation={{ required: "District is required" }}
                    className="col-span-2"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={!isEdit}
                  />
                  <Input
                    name="shortAddress"
                    type="text"
                    title="Short Address"
                    placeholder=" "
                    register={register}
                    className="col-span-3"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={!isEdit}
                  />
                  <Input
                    name="zipCode"
                    type="text"
                    title="Postal / ZIP Code"
                    placeholder=" "
                    register={register}
                    error={errors.zipCode}
                    validation={{ required: "Postal / ZIP Code is required" }}
                    className="col-span-3"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={!isEdit}
                  />
                  <Input
                    name="clientAddress"
                    type="text"
                    title="Address Line"
                    placeholder=" "
                    register={register}
                    error={errors.clientAddress}
                    validation={{ required: "Address  is required" }}
                    className="col-span-6"
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                      ? "bg-white border border-[#D8D8D8]"
                      : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                      }`}
                    disabled={!isEdit}
                  />
                </div>

                {/* Document & AWB */}
                <div className="md:divide-x md:divide-y-0 divide-y divide-[#d2d2d2] grid md:grid-cols-2 gap-4">
                  <div className="space-y-4 md:pr-4">
                    <h2 className="uppercase font-medium text-sm text-[#212121]">
                      Document
                    </h2>
                    <div className="space-y-1">
                      <label className="text-sm text-[#1E293B]">
                        VAT Percent & Number
                      </label>
                      <div className="flex items-center w-full gap-2 mb-3">
                        <Input
                          name="companyVatNo"
                          type="number"
                          placeholder=""
                          register={register}
                          error={errors.companyVatNo}
                          validation={{
                            validate: (value: string) => {
                              const trimmed = value?.trim();
                              if (trimmed && trimmed.length !== 15) {
                                return "Tax/VAT number must be 15 digits";
                              }
                              return true;
                            },
                          }}
                          className="w-full"
                          labelClass="text-sm text-[#1E293B]"
                          inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                            ? "bg-white border border-[#D8D8D8]"
                            : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                            }`}
                          disabled={!isEdit}
                        />

                        <Controller
                          control={control}
                          name="vatDoc"
                          rules={{
                            validate: (value: File | string | null) => {
                              const vatNumber = watch("companyVatNo")
                                ?.toString()
                                .trim();
                              if (vatNumber && !value)
                                return "Please select a file";
                              if (value instanceof File) {

                                const MAX_SIZE = 1 * 1024 * 1024;
                                if (value?.size > MAX_SIZE) {
                                  return "File size must be 1 MB or less";
                                }

                                const allowedTypes = [
                                  "image/jpeg",
                                  "image/png",
                                  "image/jpg",
                                  "application/pdf",
                                ];
                                if (!allowedTypes.includes(value.type)) {
                                  return "Only JPG, JPEG, PDF, or PNG files are allowed";
                                }
                              }
                              return true;
                            },
                          }}
                          render={({ field, fieldState }) => (
                            <div>
                              <input
                                type="file"
                                id="vat-doc"
                                className="hidden"
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  if (file) field.onChange(file);
                                }}
                              />
                              {field.value && !isEdit ? (
                                <a
                                  href={
                                    typeof field.value === "string"
                                      ? field.value
                                      : URL.createObjectURL(field.value as File)
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex items-center justify-center py-[10px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                                >
                                  <img
                                    src="\img\download-file-icon.svg"
                                    alt=""
                                  />
                                </a>
                              ) : (
                                <label
                                  htmlFor="vat-doc"
                                  className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                                >
                                  <IconCloudUpload stroke={1} size={20} />
                                </label>
                              )}
                              {fieldState.error && (
                                <p className="text-red-500 text-sm mt-1">
                                  {fieldState.error.message}
                                </p>
                              )}
                            </div>
                          )}
                        />
                      </div>
                    </div>
                    <div className="space-y-1">
                      <label className="text-sm text-[#1E293B]">
                        CR Number
                      </label>
                      <div className="w-full flex items-center gap-2">
                        <Input
                          name="companyCrNo"
                          type="number"
                          placeholder=""
                          register={register}
                          error={errors.companyCrNo}
                          validation={{
                            required: "CR Number is required",
                            validate: (value: string) => {
                              const trimmed = value.trim();
                              if (trimmed.length !== 10)
                                return "CR number must be 10 numbers";
                              return true;
                            },
                          }}
                          className="w-full"
                          inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                            ? "bg-white border border-[#D8D8D8]"
                            : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                            }`}
                          disabled={!isEdit}
                        />

                        <Controller
                          control={control}
                          name="crDoc"
                          rules={{
                            required: "File is required",
                            validate: (value: File | string | null) => {
                              if (!value) return "Please select a file";
                              if (value instanceof File) {
                                const MAX_SIZE = 1 * 1024 * 1024;
                                if (value?.size > MAX_SIZE) {
                                  return "File size must be 1 MB or less";
                                }

                                const allowedTypes = [
                                  "image/jpeg",
                                  "image/png",
                                  "image/jpg",
                                  "application/pdf",
                                ];
                                if (!allowedTypes.includes(value.type)) {
                                  return "Only JPG, JPEG, PDF, or PNG allowed";
                                }
                              }
                              return true;
                            },
                          }}
                          render={({ field, fieldState }) => (
                            <div>
                              <input
                                type="file"
                                id="cr-doc"
                                className="hidden"
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  if (file) field.onChange(file);
                                }}
                              />
                              {field.value && !isEdit ? (
                                <a
                                  href={
                                    typeof field.value === "string"
                                      ? field.value
                                      : URL.createObjectURL(field.value as File)
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex items-center justify-center py-[10px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                                >
                                  <img
                                    src="\img\download-file-icon.svg"
                                    alt=""
                                  />
                                </a>
                              ) : (
                                <label
                                  htmlFor="cr-doc"
                                  className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                                >
                                  <IconCloudUpload stroke={1} size={20} />
                                </label>
                              )}
                              {fieldState.error && (
                                <p className="text-red-500 text-sm mt-1">
                                  {fieldState.error.message}
                                </p>
                              )}
                            </div>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="space-y-4 md:pl-4 md:pt-0 pt-4">
                    <h2 className="uppercase font-medium text-sm text-[#212121]">
                      AWb Info
                    </h2>
                    <div className="grid grid-cols-2 gap-4">
                      <Input
                        name="lmAwbNumber"
                        type="text"
                        title="Fulfillment"
                        placeholder=""
                        register={register}
                        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                          ? "bg-white border border-[#D8D8D8]"
                          : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                          }`}
                        disabled={true}
                      />
                      <Input
                        name="lmAwbNumber"
                        type="text"
                        title="Lastmiles"
                        placeholder=""
                        register={register}
                        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                          ? "bg-white border border-[#D8D8D8]"
                          : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                          }`}
                        disabled={true}
                      />
                      <Input
                        name="tollFreeNo"
                        type="number"
                        title="AWB Toll Free No"
                        placeholder=""
                        register={register}
                        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                          ? "bg-white border border-[#D8D8D8]"
                          : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                          }`}
                        disabled={!isEdit}
                      />
                      <Input
                        name="systemMail"
                        type="email"
                        title="Info Email"
                        placeholder=""
                        register={register}
                        error={errors.systemMail}
                        validation={{ required: "Info Email is required" }}
                        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                          ? "bg-white border border-[#D8D8D8]"
                          : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                          }`}
                        disabled={!isEdit}
                      />
                    </div>
                  </div>
                </div>

                {/* Edit/Save button */}
                <div className="pt-4">
                  <button
                    type={isEdit ? "submit" : "button"}
                    onClick={() => {
                      isEdit ? handleSubmit(onSubmit)() : setIsEdit(!isEdit);
                    }}
                    className="bg-[#FBD037] text-[#212121] text-base font-semibold p-2.5 rounded-full"
                  >
                    {isEdit ? <IconDeviceFloppy /> : <IconEdit />}
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </div>

      {/* Configuration and Password sections unchanged */}
      {!isStaff && (
        <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] space-y-4">
          <div
            onClick={() => toggleSection("config")}
            className="flex justify-between items-center cursor-pointer"
          >
            <h2 className="uppercase font-medium text-base text-[#212121]">
              Configuration
            </h2>
            {openSection === "config" ? (
              <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
            ) : (
              <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
            )}
          </div>
          {openSection === "config" && <Configuration />}
        </div>
      )}

      <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] space-y-4">
        <div
          onClick={() => toggleSection("resetPassword")}
          className="flex justify-between items-center cursor-pointer"
        >
          <h2 className="uppercase font-medium text-base text-[#212121]">
            Reset Password
          </h2>
          {openSection === "resetPassword" ? (
            <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
          ) : (
            <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
          )}
        </div>
        {openSection === "resetPassword" && <Password />}
      </div>
    </div>
  );
}
